module.exports = __webpack_public_path__ + "static/media/Fast_Shipping _Clock.4b0e6f02.svg";